module.exports = __webpack_public_path__ + "static/media/IMG_1197.ebf28f46.jpg";